module.exports = __webpack_public_path__ + "fonts/Didot.79540cd1.woff";